export default class AutoSaveTextField {
  constructor(caller, opts = {}) {
    this.attrName = opts.attrName;
    this.klass = opts.klass;
    this.submitUrl = opts.submitUrl;
    this.fieldId = `${this.klass}_${this.attrName}`;
    this.caller = caller;

    this.bindTextFieldOnBlur();
    this.bindTextFieldOnFocus();
  }

  bindTextFieldOnBlur() {
    N2.handle("blur", `#${this.fieldId}`, (e) => {
      const text = e.target.value;

      if (text !== this.fieldValue) {
        const form = new N2Styles.manualForm();
        form.setRootParam(this.klass);
        form.form.attr("method", "post");
        form.setUrl(this.submitUrl);
        form.addInput(this.attrName, text);

        form.sync({
          success: (resp) => {
            this.onComplete(resp);
          },
          error: (req) => {
            this.onError(req.resonseJSON);
          },
          context: this,
        });
      } else {
        this.enableButtons();
      }
      // Allow the caller to update it's page
      this.caller.runCallbacks();
    });
  }

  bindTextFieldOnFocus() {
    N2.handle("focus", `#${this.fieldId}`, () => {
      this.enabledButtons = $(":enabled").not(":input[type=url], :input[type=text]");
      this.fieldValue = this.findFieldValue();
      this.disableButtons();
    });
  }

  disableButtons() {
    this.enabledButtons.prop("disabled", true);
  }

  enableButtons() {
    this.enabledButtons.prop("disabled", false);
  }

  findFieldValue() {
    return $(`#${this.fieldId}`)[0].value;
  }

  onComplete(resp) {
    this.showToast(resp.message);
    this.enableButtons();
  }

  onError(resp) {
    this.showToast(resp.message);
    this.resetField();
    this.enableButtons();
  }

  resetField() {
    $(`#${this.fieldId}`).val(this.fieldValue);
  }

  showToast(msg) {
    new N2Styles.toast(msg);
  }
}
